import React from 'react';
import { PainSection } from './PainSection';
import { ProductIntro } from './ProductIntro';
import { ModulesSection } from './ModulesSection';
import { BonosSection } from './BonosSection';
import { ValueStack } from './ValueStack';
import { AudienceSection } from './AudienceSection';
import { Testimonials } from './Testimonials';
import { HowItWorks } from './HowItWorks';
import { Guarantee } from './Guarantee';
import { ClosingBlock } from './ClosingBlock';
import { FAQ } from './FAQ';
import { Footer } from './Footer';
import { SocialProofPopup } from './SocialProofPopup';
import { FloatingCTA } from './FloatingCTA';
export function DeferredLanding() {
  return <>
      <PainSection data-id="element-57" data-mp="x0n93ghtaigd" />
      <ProductIntro data-id="element-58" data-mp="x0ddnddzzj3a" />
      <ModulesSection data-id="element-59" data-mp="x1y7f0shmy03" />
      <BonosSection data-id="element-60" data-mp="x1eyuaoq9lyq" />
      <ValueStack data-id="element-61" data-mp="1bxxf4aboqw4p" />
      <AudienceSection data-id="element-62" data-mp="1bxe6jk7xdk3c" />
      <Testimonials data-id="element-63" data-mp="1byyz54aoisyk" />
      <HowItWorks data-id="element-64" data-mp="1by5ss4fmu5gy" />
      <Guarantee data-id="element-65" data-mp="1bvjku3otxny7" />
      <ClosingBlock data-id="element-66" data-mp="16z2wp9hmr9l4" />
      <FAQ data-id="element-67" data-mp="16zm6u411gtol" />
      <Footer data-id="element-68" data-mp="17049pji7i65h" />
      <div className="h-[54px] md:hidden" aria-hidden="true" data-id="element-69" data-mp="170e2feumyrev" />
      <SocialProofPopup data-id="element-70" data-mp="1xxox8kyymwyg" />
      <FloatingCTA data-id="element-71" data-mp="1xy8dlx8ypdad" />
    </>;
}